import ApplicationController from './application_controller'

// The SLA matrix accepts three of the four pairs the two selects can form.
// Without this, picking an unsupported one submitted and the reader got the
// refusal from the server after the fact — reported in staging QA. One combined
// select prevented it too, but it lined up under neither of the two columns.
//
// The end select is marked invalid, so the browser refuses the submit, and the
// message is written under it: SlimSelect hides the native select, so the
// browser's own bubble had nothing to show on and the refusal was silent. The
// server still validates.
export default class extends ApplicationController {
  static targets = ['start', 'end', 'error']
  static values = { supported: Array, message: String }

  connect () {
    this.validate()
  }

  validate () {
    const message = this.supported() ? '' : this.messageValue
    this.endTarget.setCustomValidity(message)
    this.errorTarget.textContent = message
  }

  supported () {
    return this.supportedValue.some(
      (pair) => pair[0] === this.startTarget.value && pair[1] === this.endTarget.value
    )
  }
}
